import api from './axiosConfig';
const url = '/api/personas';

export const registrarPersona = async (data) => {
  try {
    const response = await api.post(url+'/registrar/persona', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerUsuarios = async () => {
  try {
    const response = await api.get(url+'/ver/usuarios', {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const restablecerContrasena = async (data) => {
  try {
    const response = await api.post(url+'/restablecer-contrasena', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};